import React, { useState } from "react";
import { Drawer } from "antd5";

import { white } from "../../lib/themes/colors";
import { ContactFilters } from "./contactUtils";
import { FilterForm } from "./FilterForm";

import css from "./ContactsFilterDrawer.module.scss";

type ContactsFilterDrawerProps = {
  isOpen: boolean;
  contactFilters: ContactFilters;
  clearFilters: () => void;
  onClose: () => void;
  onChangeSearchFilters: (filters: Partial<ContactFilters>) => void;
};

function ContactsFilterDrawer({
  isOpen,
  contactFilters,
  onClose,
  onChangeSearchFilters,
}: ContactsFilterDrawerProps): JSX.Element {
  const [activeGroups, setActiveGroups] = useState<string[]>([]);
  const [isClosing, setIsClosing] = useState(false);

  const closeDrawer = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300);
  };

  return (
    <>
      {(isClosing || isOpen) && (
        <Drawer
          width={700}
          className={css.drawer}
          styles={{ body: { padding: 0 }, content: { backgroundColor: white } }}
          open={isOpen && !isClosing}
          closeIcon={null}
          onClose={closeDrawer}
        >
          <FilterForm
            onChange={onChangeSearchFilters}
            onClose={closeDrawer}
            filters={contactFilters}
            activeGroups={activeGroups}
            onActiveGroupChange={setActiveGroups}
          />
        </Drawer>
      )}
    </>
  );
}

export default ContactsFilterDrawer;
